import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {HOSTNAME} from "../../Configs/Domain";
import {prepareJsonPayload, getValuesByPaths} from "../utils";


export const fetchProspectsStats = createAsyncThunk(
  'prospects/fetchProspectsStats',
  async (prospectIds, { getState, dispatch, rejectWithValue }) => {
    try {
      const response = await fetch(`${HOSTNAME}/prospects/stats`, prepareJsonPayload({
        data: {
            prospect_ids: prospectIds
        }
      }));
      if (!response.ok) throw new Error('Failed to fetch user fields');
      const responseData = await response.json();
      console.log(responseData)
      return responseData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
)



const prospectsSlice = createSlice({
    name: 'prospects',
    initialState: {
        sessionStats: [],
        prospectSessions: {},
        status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
        error: null,

    },
    reducers: {},
    extraReducers: (builder) => {
        builder
          .addCase(fetchProspectsStats.pending, (state) => {
            state.status = 'loading';
          })
          .addCase(fetchProspectsStats.fulfilled, (state, action) => {
              console.log(state)
            state.status = 'succeeded';
            state.sessionStats = action.payload;
          })
          .addCase(fetchProspectsStats.rejected, (state, action) => {
            state.status = 'failed';
            state.error = action.payload;  // or action.error.message if error handling is structured that way
          });
      }
});
export default prospectsSlice.reducer;
